module.exports = __webpack_public_path__ + "img/1.dcc86dd7.png";